<template>
  <button class="btn btn-primary" @click="save" :disabled="errors.any() || submitted || pending">
    <i v-if="submitted" class="far fa-spinner-third fa-spin"></i> Save
  </button>
</template>
<script>
export default {
  inject: ['$validator'],
  name: 'SaveButton',
  props: {
    onSave: {
      type: Function
    },
    redirect: {
      type: String
    },
    method: {
      validator: (val) => ['get', 'post', 'put', 'patch', 'delete'].includes(val),
      type: String
    },
    url: {
      type: String
    },
    data: {
      type: Object
    }
  },
  data() {
    return { submitted: false, pending: false };
  },
  methods: {
    async save() {
      try {
        await this.$validator.validateAll();
        if (this.errors.any()) return;
        this.$emit('onStartSave');
        this.pending = true;
        if (this.onSave) {
          await this.onSave();
        } else {
          const res = await this.http[this.method](this.url, this.data);
          this.submitted = false;
          this.$emit('save', res);
          if (this.redirect) {
            this.$router.push(this.redirect);
          }
        }
      } catch (e) {
        this.$emit('onError', e);
      } finally {
        this.pending = false;
      }
    }
  }
};
</script>
